<template>
    <v-tab-item class="fill-height">

        <div class="text-center mb-20 mb-lg-40">
            <h3 class="tit mb-8 mb-lg-16">미팅참여 지원자 선택</h3>
            <p class="page-text--lg grey-6--text">면접을 진행할 공고를 선택한 후 다음 단계로 넘어가 주세요.</p>
        </div>

        <v-expansion-panels v-model="panels" flat multiple>
            <template v-for="(stage, index) in stages">
                <v-expansion-panel :key="stage.value" :class="{ 'mb-10 grey-f1': index != stages.length - 1, 'grey-5f white--text': index == stages.length - 1 }" class="rounded mh-300px scroll-primary" style="overflow-y: auto;">
                    <!-- <v-expansion-panel-header class="font-size-16 font-size-lg-20"> {{ stage.text }} ({{ stage.items.length }}) </v-expansion-panel-header> -->
                    <v-expansion-panel-header class="font-size-16 font-size-lg-20">
                        <div class="px-12 px-md-20">
                            <v-layout align-center>
                                <i :class="'mr-4 mr-lg-10 icon icon-dot icon-dot--'+stage.color" />
                                <p class="page-text--lg font-weight-medium">{{ stage.text }}</p>
                            </v-layout>
                        </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <application-card v-for="item in stage.items" :key="item._id" :value="item" v-bind="{ recruitment }" :isSelected="value.some(({ _id }) => _id == item._id)" selectable class="mt-10" @select="toggle(item)" />
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </template>
        </v-expansion-panels>

        <v-fade-transition>
            <v-overlay v-show="loading" absolute color="white">
                <v-progress-circular color="black" size="100" width="5" indeterminate />
            </v-overlay>
        </v-fade-transition>

        <div class="v-btn-group">
            <v-btn outlined color="grey-d" class="min-w-140px min-w-lg-160px" @click="$emit('prev')">
                <span class="grey-6--text">이전으로</span>
            </v-btn>
            <v-btn color="primary" class="min-w-140px min-w-lg-160px" @click="$emit('next')">
                <span>저장 후 다음으로</span>
            </v-btn>
        </div>

        <!-- <v-layout column align-center fill-height style="overflow-y: hidden">
            <v-card-text class="d-flex flex-column" style="position: relative; flex: 1 1 auto; overflow-y: hidden">
                <v-sheet style="overflow-y: auto" class="pa-10">
                    <v-expansion-panels v-model="panels" flat multiple>
                        <template v-for="(stage, index) in stages">
                            <v-expansion-panel :key="stage.value" :class="{ 'mb-10 grey-f1': index != stages.length - 1, 'grey darken-2 white--text': index == stages.length - 1 }">
                                <v-expansion-panel-header class="font-size-16 font-size-lg-20"> {{ stage.text }} ({{ stage.items.length }}) </v-expansion-panel-header>
                                <v-expansion-panel-header class="font-size-16 font-size-lg-20">
                                    <p class="d-flex align-center"><i class="icon icon-dot icon-dot--primary mr-4" />{{ stage.text }}</p>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <application-card v-for="item in stage.items" :key="item._id" :value="item" v-bind="{ recruitment }" :isSelected="value.some(({ _id }) => _id == item._id)" selectable class="my-10" @select="toggle(item)" />
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </template>
                    </v-expansion-panels>
                </v-sheet>
                <v-fade-transition>
                    <v-overlay v-show="loading" absolute color="white">
                        <v-progress-circular color="black" size="100" width="5" indeterminate />
                    </v-overlay>
                </v-fade-transition>
            </v-card-text>
            <v-card-actions class="justify-center">
                <v-btn outlined @click="$emit('prev')"> 이전으로</v-btn>
                <v-btn color="primary" @click="$emit('next')"> 저장 후 다음으로 </v-btn>
            </v-card-actions>
        </v-layout> -->

    </v-tab-item>
</template>

<script>
import api from "@/api";

import ApplicationCard from "../../application/application-card.vue";

import { RECRUITMENT_KANBAN_FIELDS } from "@/assets/variables";

export default {
    components: {
        ApplicationCard,
    },
    props: {
        value: { type: Array, default: () => [] }, // applications
        recruitment: { type: Object, default: () => ({}) },
    },
    data: () => ({
        applications: [],

        loading: false,
        panels: [0],
    }),
    computed: {
        _recruitment() {
            return this.recruitment?._id;
        },
        stages() {
            return Object.values(RECRUITMENT_KANBAN_FIELDS).map((field) => ({ ...field, items: this.applications.filter((item) => item?.stage == field?.stage) }));
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        _recruitment() {
            this.init();
        },
    },
    methods: {
        async init() {
            if (this.loading) return;
            if (!this._recruitment) return;
            this.applications = [];
            this.loading = true;
            try {
                let { skip, limit, _recruitment } = this;
                const { summary, applications } = await api.v1.company.recruitments.applications.gets({
                    headers: { skip, limit },
                    _recruitment,
                });

                this.summary = summary;
                this.applications = applications;
            } finally {
                this.loading = false;
            }
        },

        toggle(item) {
            const isInValue = this.value.some(({ _id }) => _id == item._id);
            let items = isInValue ? this.value.filter(({ _id }) => _id != item._id) : [...this.value, item];
            this.$emit("input", items);
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .v-expansion-panel-header{
    padding: 10px 10px 20px 10px;
}
::v-deep .v-expansion-panel-content__wrap{
    padding: 0 10px 20px;
}
::v-deep .v-expansion-panel--active+.v-expansion-panel, .v-expansion-panel--active:not(:first-child) {
    margin-top: 0;
}
@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
    ::v-deep .v-expansion-panel-header{
        padding: 20px 10px;
    }
}
@media (min-width:1200px){
}

</style>
